<template>
  <v-layout>
    <v-flex xs12>
      <business-trip-request-expense-form refreshable v-model="expense"
                                          @refresh="refresh" @save="save"
                                          @input="change" @close="close"
                                          v-if="loaded" />
      <v-card v-else>
        <v-card-text><h2>Loading...</h2></v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import BusinessTripRequestExpenseForm from './BusinessTripRequestExpenseForm'
import _ from 'lodash'
import Vuex from 'vuex'
import Promise from 'promise-polyfill'

const btRequestExpensesStore = Vuex.createNamespacedHelpers('BusinessTripRequest/Expenses')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')

function getBackRoute (vm) {
  return vm.backRoute || {name: 'business-trip-request-expense', params: {id: vm.id, empid: vm.empid}}
}

export default {
  name: 'business-trip-request-expense-new',
  components: {
    BusinessTripRequestExpenseForm
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    empid: {
      type: [String, Number],
      required: true
    },
    backRoute: {
      type: [String, Object],
      required: false,
      default: null
    }
  },
  data () {
    return {
      test: '',
      expense: {},
      modified: false,
      loaded: false
    }
  },
  methods: {
    ...btRequestExpensesStore.mapActions({
      getNewExpense: 'getNewExpense',
      addExpense: 'addExpense'
    }),
    ...dialogsStore.mapActions({
      showConfirmation: 'showConfirmation',
      closeConfirmation: 'closeConfirmation'
    }),
    loadResources () {
      const self = this
      const resources = [self.getNewExpense({vueinstance: self})]

      Promise.all(resources)
        .then(res => {
          self.expense = _.cloneDeep(res[0])
          if (self.expense.tripDate === null) {
            self.expense.tripDate = new Date(self.$options.filters.moment(Date.now(), 'YYYY-MM-DD')).getTime()
          }
          self.loaded = true
        })
        .catch(err => self.$error(err))
    },
    refresh () {
      this.loadResources()
    },
    change () {
      this.modified = true
    },
    save (expense) {
      const self = this

      self.addExpense({vueinstance: self, id: self.id, empid: self.empid, exp: self.expense})
        .then(res => {
          self.loaded = false
          self.expense = _.cloneDeep(res)
          self.loaded = true
          self.modified = false
          self.$success('Business Trip Request Expense saved')
          self.$router.replace(getBackRoute(self))
        })
        .catch(err => {
          self.$error(err)
        })
    },
    close () {
      const self = this
      if (!self.modified) {
        this.$router.replace(getBackRoute(self))
      } else {
        const yesHandler = () => {
          this.$router.replace(getBackRoute(self))
          self.closeConfirmation()
        }

        const noHandler = () => {
          self.closeConfirmation()
        }

        self.showConfirmation({
          message: 'Are you sure?',
          title: 'Closing. This Business Trip Request Expense will not saved.',
          buttons: [{label: 'Yes', handler: yesHandler}, {label: 'No', handler: noHandler}]
        })
      }
    }
  },
  mounted () {
    if (!this.loaded) {
      this.loadResources()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/business-trip/BusinessTripRequestExpenseNew.vue